export default __webpack_public_path__ + "static/FilsonSoftBook-Italic-04e54d49a4217db1ef8ab83b573c8316.ttf";